import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const detectify = defineConnector({
  identifier: "detectify",
  name: "Detectify",
  tagLine: "External attack surface management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.detectify\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Generate a V3 API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Detectify](https://app.detectify.com), go to **Settings → API keys** and generate a new key for the V3 API.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Detectify API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.detectify.com/rest/v3/ips",
  },
});
